import { BeforeAfter } from "@/components/landing/Proof";
import { CheckCircle2 } from "lucide-react";

const NEXT = ["We review your furniture", "We recommend the right service", "We walk you through your personalized options"];

export const SuccessState = ({ result, gallery, firstName }) => (
  <div className="p-6 sm:p-10" data-testid="success-state">
    <CheckCircle2 size={48} strokeWidth={1.2} className="text-[#c19a6b]" />
    <h3 className="font-display text-3xl sm:text-4xl tracking-tight mt-6" data-testid="success-headline">We've got your furniture.</h3>
    <p className="text-gray-700 leading-relaxed mt-5">
      {firstName ? `Thank you, ${firstName.trim()}. ` : ""}Our team will review your photos and project details to determine whether ARK Furniture Revival looks like the right service for your piece.
    </p>
    <p className="text-gray-600 leading-relaxed mt-4">
      If it looks like a good candidate, we'll reach out to ask a few questions and walk you through what we'd recommend.
    </p>
    {result?.lead_number && (
      <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400 mt-6" data-testid="success-reference">Reference {result.lead_number}</p>
    )}

    <div className="mt-10 border-t border-gray-200 pt-8">
      <p className="text-[11px] uppercase tracking-[0.25em] text-[#c19a6b] font-bold">What happens next?</p>
      <ol className="mt-5 space-y-3">
        {NEXT.map((t, i) => (
          <li key={t} className="flex items-start gap-4">
            <span className="font-display text-2xl text-[#c19a6b]/70 leading-none w-6 shrink-0">{i + 1}</span>
            <span className="text-[15px] leading-snug pt-0.5">{t}</span>
          </li>
        ))}
      </ol>
    </div>

    {gallery?.[0] && (
      <div className="mt-10 border-t border-gray-200 pt-8">
        <p className="text-[11px] uppercase tracking-[0.25em] text-gray-400 font-bold mb-4">A recent Revival</p>
        <BeforeAfter item={gallery[0]} />
      </div>
    )}
  </div>
);
